import { takeEvery, put, select, all } from 'redux-saga/effects'
import { getAccessToken } from '@medeo/user'
import {
  CREATING_GOALS,
  receiveGoals,
  receiveGoal,
  LOADING_GOALS,
  EDITING_GOALS
} from './actions'
import { getCurrentPatient } from '@medeo/patients'
import { createCarePlan } from '../Careplan/actions'

const FHIR_URL = process.env.FHIR_URL

function* rootSaga() {
  yield takeEvery(CREATING_GOALS, createGoals)
  yield takeEvery(EDITING_GOALS, editGoals)
  yield takeEvery(LOADING_GOALS, loadGoalsFromPatientId)
}

function* loadGoalsFromPatientId(action) {
  const patientId = action.payload
  const accessToken = yield select(getAccessToken)
  const goalsRequest = yield fetch(`${FHIR_URL}/goals/${patientId}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
    }
  })

  const goals = yield goalsRequest.json()
  yield put(receiveGoals(goals))
}

function* createGoals(action) {
  const { goals, frequencies, measuresTypes } = action.payload
  const patient = yield select(getCurrentPatient)

  const normalizedGoals = goals.map(goal => {
    goal.subject = {
      reference: `${FHIR_URL}/patients/${patient.id}`,
      identifier: {
        use: 'usual',
        value: patient.id
      }
    }
    return goal
  })
  const savedGoals = yield saveAllGoals(normalizedGoals)
  yield put(createCarePlan({ goals: savedGoals, frequencies, measuresTypes }))
}

export default rootSaga

function* editGoals(action) {
  const goals = action.payload
  yield updateAllGoals(goals)
}

function* saveAllGoals(goals) {
  const savedGoals = yield all(goals.map(goal => saveGoal(goal)))
  return savedGoals
}
function* updateAllGoals(goals) {
  const updatedGoals = yield all(goals.map(goal => updateGoal(goal)))
  return updatedGoals
}
function* saveGoal(goal) {
  try {
    const accessToken = yield select(getAccessToken)
    const response = yield fetch(`${FHIR_URL}/goals`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      },
      body: JSON.stringify(goal)
    })
    const returnedGoal = yield response.json()

    yield put(receiveGoal(returnedGoal))
    return returnedGoal
  } catch (error) {
    console.log(error)
  }
}
function* updateGoal(goal) {
  try {
    const accessToken = yield select(getAccessToken)
    const response = yield fetch(`${FHIR_URL}/goals/${goal.id}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...(accessToken != null && { Authorization: `Bearer ${accessToken}` })
      },
      body: JSON.stringify(goal)
    })
    const returnedGoal = yield response.json()

    yield put(receiveGoal(returnedGoal))
    return returnedGoal
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/Goal/sagas.js